<template>
  <div
    class="container"
    data-testid="settings-cloud-tab-pending"
  >
    <div class="row">
      <h2
        class="ibf-h2"
        data-testid="settings-cloud-tab-pending--title"
      >
        {{ getTitle }}
      </h2>
    </div>
    <div class="row spinner-wrapper">
      <!-- <propagate-loader :color="'#49DEAC'"></propagate-loader> -->
    </div>
    <div class="row place-holder">&nbsp;</div>
  </div>
</template>

<script>
// import { PropagateLoader } from '@saeris/vue-spinners';

import { CLOUD_STATUS } from '@/views/settings/settingsCloud/cloud.const';

let timeoutHandler;
export default {
  name: 'CloudPending',
  components: {
    // PropagateLoader,
  },
  props: { cloudStatus: { type: String } },
  computed: {
    getTitle() {
      if ([CLOUD_STATUS.Creating, CLOUD_STATUS.Deleting, CLOUD_STATUS.Deactivating, CLOUD_STATUS.InProcess, CLOUD_STATUS.Waiting].includes(this.cloudStatus)) {
        return this.$t(`settings.cloud.status.${this.cloudStatus}`);
      }
      return '';
    },
  },
  watch: {
    cloudStatus(val) {
      if (val === 'Waiting') {
        timeoutHandler = setTimeout(() => this.$store.commit('settings/setCloudStatus', 'Error'), 7000);
      } else {
        clearTimeout(timeoutHandler);
      }
    },
  },
  unmounted() {
    clearTimeout(timeoutHandler);
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.place-holder {
  height: 100px;
}
</style>
